import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
// css
import styles from "./index.module.scss";
import { CloseIcon } from "Assets/icons";
import { cloneDeep, debounce } from "lodash";
import { CstmPagination, NoRecordFound } from "components/Common/Common";
import { useGetResourceListQuery } from "store/services/resource";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";

const AttachResourcesPopup = ({ show, setShow, defaultResources = [], handleSubmit }) => {
	const [selected, setSelected] = useState(defaultResources);
	const [page, setPage] = useState()
	const [search, setSearch] = useState("");
	const pageSize = 10;

	const { data, isLoading, isFetching, isError } = useGetResourceListQuery({ page, search });
	const resources = data?.records;
	const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

	const resourcesOptions = useMemo(() => {
		if(!resources?.length) {
			return [];
		}

		return resources?.map(item => ({
			value: {
				attachment_key: item.attachment_key,
				attachment_name: item.attachment_name,
			},
			label: item.attachment_name,
		}))

	}, [resources]);

	// set default selected resources
	useEffect(() => {
		setSelected(defaultResources)
	}, [defaultResources])

	const closePopup = () => {
		setPage(1);
		setSearch("");
		setShow(!show)
	}

	const handlePageChange = (page) => {
    setPage(page);
  };

	const handleSearchChange = useCallback(debounce((e) => {
		setSearch(e.target.value);
	}, 500), []);

	const handleSelectionChange = (value) => {
		const selectedClone = cloneDeep(selected);
		const existingIndex = selectedClone.findIndex(item => item.attachment_key === value.attachment_key);
		if(existingIndex !== -1) {
			selectedClone.splice(existingIndex, 1);
		} else {
			selectedClone.push(value)
		}

		setSelected(selectedClone);
	}

	const handleClickSave = () => {
		handleSubmit(selected);
		closePopup();
	}

	return (
		<>
			<Modal
				show={show}
				className={`${styles.AssignChecklist}  AssignChecklist`}
				onHide={closePopup}
				backdrop="static"
				keyboard={false}
				centered
				scrollable="true"
				size="md"
			>
				<Modal.Body className={`${styles.modalBody} position-relative rounded`}>
					<Button
						onClick={closePopup}
						className="border-0 p-0 position-absolute"
						variant="transparent"
						style={{ right: 10, top: 0 }}
					>
						<CloseIcon />
					</Button>
					<div>
						<h6 className="m-0 fw-bold themeBlue">Add Attachment</h6>
					</div>
					<Row>
						<Col className="col-12 my-2">
							{isLoading ? (
								<LoadingIndicator />
							): isError ? (
								<ErrorComponent />
							):(
								<>
									{isFetching && (
										<LoadingOverlay />
									)}
									<div className="iconWithText position-relative">
										<form>
											<Col md="12" sm="12" className="my-2">
												<div className="top">
													<div className="iconWithText position-relative">
														<input
															type="text"
															placeholder="Search resources"
															className="form-control"
															style={{ height: 40 }}
															onChange={handleSearchChange}
														/>
														<span className="icn position-absolute" style={{ right: 5 }}>
															<svg
																xmlns="http://www.w3.org/2000/svg"
																width="16"
																height="16"
																viewBox="0 0 16 16"
																fill="none"
															>
																<path
																	d="M14.2621 15.5737L9.27139 10.8843C8.81306 11.2627 8.28598 11.5589 7.69014 11.7728C7.09431 11.9867 6.47793 12.0936 5.841 12.0936C4.27426 12.0936 2.9483 11.5512 1.86312 10.4663C0.777942 9.38143 0.235352 8.05578 0.235352 6.48935C0.235352 4.92307 0.777789 3.59696 1.86266 2.51101C2.94754 1.42522 4.27319 0.882324 5.83962 0.882324C7.4059 0.882324 8.73201 1.42491 9.81796 2.51009C10.9037 3.59527 11.4466 4.92123 11.4466 6.48797C11.4466 7.14262 11.3368 7.76787 11.1171 8.3637C10.8973 8.95953 10.604 9.47776 10.2373 9.91837L15.228 14.6076L14.2621 15.5737ZM5.841 10.7188C7.02212 10.7188 8.02251 10.3089 8.84216 9.48914C9.66197 8.66948 10.0719 7.6691 10.0719 6.48797C10.0719 5.30685 9.66197 4.30646 8.84216 3.4868C8.02251 2.667 7.02212 2.25709 5.841 2.25709C4.65987 2.25709 3.65948 2.667 2.83983 3.4868C2.02003 4.30646 1.61012 5.30685 1.61012 6.48797C1.61012 7.6691 2.02003 8.66948 2.83983 9.48914C3.65948 10.3089 4.65987 10.7188 5.841 10.7188Z"
																	fill="#1C1B1F"
																/>
															</svg>
														</span>
													</div>
												</div>
												{resourcesOptions?.length ? (
													<ul className="list-unstyled mt-3">
														{resourcesOptions.map((resource, index) => (
															<li
																key={index}
																className="d-flex align-items-center gap-10 my-1"
															>
																<input
																	id={`resource_${resource.value.attachment_key}`}
																	type="checkbox"
																	className="form-check m-0"
																	checked={selected.find(item => item.attachment_key === resource.value.attachment_key) ? true : false}
																	onChange={() => handleSelectionChange(resource.value)}
																/>
																<label for={`resource_${resource.value.attachment_key}`} className="m-0 themeBlue">
																	{resource.label}
																</label>
															</li>
														))}
													</ul>
												):(
													<NoRecordFound />
												)}
												<div className="pb-2">
													<CstmPagination
														totalPages={totalPages}
														activePage={page}
														handlePageChange={handlePageChange}
													/>
												</div>
											</Col>
											<Col md="12" sm="12" className="my-2 d-flex justify-content-center">
												<Button
													className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
													onClick={handleClickSave}
												>
													Save
												</Button>
											</Col>
										</form>
									</div>
								</>
							)}
						</Col>
					</Row>
				</Modal.Body>
			</Modal >
		</>
	);
};

export default AttachResourcesPopup;